export type JoinPaths<A extends string, B extends string> = A extends ''
	? B
	: B extends ''
		? A
		: `${A extends `${infer a}/` ? a : A}/${B extends `/${infer b}` ? b : B}`;

/**
 * Join two URL paths together with a forward slash between them.
 */
export function joinPaths<A extends string, B extends string>(
	a: A,
	b: B
): JoinPaths<A, B>;

// Use a single strictly-typed overload and a loosely-typed implementation
// because Typescript cannot type-check the implementation.
export function joinPaths(a: string, b: string): string {
	if (a === '') return b;
	if (b === '') return a;
	return `${a.replace(/\/$/u, '')}/${b.replace(/^\//u, '')}`;
}
